import {Exchange} from "../../../instruments/exchange/Exchange";
import {CodeAndExchange} from "../../../instruments/types/CodeAndExchange";

type AsxFixedInterests = ReadonlyArray<CodeAndExchange>;

export const fixedInterests: AsxFixedInterests = [
    { code: "ABOHG", exchange: Exchange.ASX },
    { code: "ABOHH", exchange: Exchange.ASX },
    { code: "AF1HA", exchange: Exchange.ASX },
    { code: "AF2HA", exchange: Exchange.ASX },
    { code: "AF3HA", exchange: Exchange.ASX },
    { code: "AF4HA", exchange: Exchange.ASX },
    { code: "AFTHA", exchange: Exchange.ASX },
    { code: "AN3HAU", exchange: Exchange.ASX },
    { code: "AN3HAV", exchange: Exchange.ASX },
    { code: "AN3HAW", exchange: Exchange.ASX },
    { code: "AN3HAX", exchange: Exchange.ASX },
    { code: "AN3HAY", exchange: Exchange.ASX },
    { code: "AN3HAZ", exchange: Exchange.ASX },
    { code: "AN3HBA", exchange: Exchange.ASX },
    { code: "AN3HBB", exchange: Exchange.ASX },
    { code: "AN3HBC", exchange: Exchange.ASX },
    { code: "AN3HBD", exchange: Exchange.ASX },
    { code: "AN3HBE", exchange: Exchange.ASX },
    { code: "AN3HBF", exchange: Exchange.ASX },
    { code: "ANVHA", exchange: Exchange.ASX },
    { code: "ANVHAA", exchange: Exchange.ASX },
    { code: "ANVHAB", exchange: Exchange.ASX },
    { code: "ANVHAC", exchange: Exchange.ASX },
    { code: "ANVHAD", exchange: Exchange.ASX },
    { code: "ANVHAE", exchange: Exchange.ASX },
    { code: "ANVHAF", exchange: Exchange.ASX },
    { code: "ANVHB", exchange: Exchange.ASX },
    { code: "ANVHC", exchange: Exchange.ASX },
    { code: "ANVHD", exchange: Exchange.ASX },
    { code: "ANVHE", exchange: Exchange.ASX },
    { code: "ANVHF", exchange: Exchange.ASX },
    { code: "ANVHG", exchange: Exchange.ASX },
    { code: "ANVHH", exchange: Exchange.ASX },
    { code: "ANVHI", exchange: Exchange.ASX },
    { code: "ANVHJ", exchange: Exchange.ASX },
    { code: "ANVHK", exchange: Exchange.ASX },
    { code: "ANVHL", exchange: Exchange.ASX },
    { code: "ANVHM", exchange: Exchange.ASX },
    { code: "ANVHN", exchange: Exchange.ASX },
    { code: "ANVHO", exchange: Exchange.ASX },
    { code: "ANVHP", exchange: Exchange.ASX },
    { code: "ANVHQ", exchange: Exchange.ASX },
    { code: "ANVHR", exchange: Exchange.ASX },
    { code: "ANVHS", exchange: Exchange.ASX },
    { code: "ANVHT", exchange: Exchange.ASX },
    { code: "ANVHU", exchange: Exchange.ASX },
    { code: "ANVHV", exchange: Exchange.ASX },
    { code: "ANVHW", exchange: Exchange.ASX },
    { code: "ANVHX", exchange: Exchange.ASX },
    { code: "ANVHY", exchange: Exchange.ASX },
    { code: "ANVHZ", exchange: Exchange.ASX },
    { code: "ANZHAL", exchange: Exchange.ASX },
    { code: "ANZHAM", exchange: Exchange.ASX },
    { code: "ANZHAN", exchange: Exchange.ASX },
    { code: "ANZHAO", exchange: Exchange.ASX },
    { code: "ANZHAP", exchange: Exchange.ASX },
    { code: "ANZHAQ", exchange: Exchange.ASX },
    { code: "ANZHAR", exchange: Exchange.ASX },
    { code: "ANZHAS", exchange: Exchange.ASX },
    { code: "ANZHAT", exchange: Exchange.ASX },
    { code: "AO2HA", exchange: Exchange.ASX },
    { code: "AO3HA", exchange: Exchange.ASX },
    { code: "AO3HB", exchange: Exchange.ASX },
    { code: "AO3HC", exchange: Exchange.ASX },
    { code: "AOJHA", exchange: Exchange.ASX },
    { code: "AOJHB", exchange: Exchange.ASX },
    { code: "AOLHA", exchange: Exchange.ASX },
    { code: "AORHA", exchange: Exchange.ASX },
    { code: "AOYHA", exchange: Exchange.ASX },
    { code: "AP2HA", exchange: Exchange.ASX },
    { code: "AP2HB", exchange: Exchange.ASX },
    { code: "AP2HC", exchange: Exchange.ASX },
    { code: "AQHHB", exchange: Exchange.ASX },
    { code: "AQHHC", exchange: Exchange.ASX },
    { code: "AQHHD", exchange: Exchange.ASX },
    { code: "AQMHA", exchange: Exchange.ASX },
    { code: "ATBHB", exchange: Exchange.ASX },
    { code: "ATBHG", exchange: Exchange.ASX },
    { code: "ATBHH", exchange: Exchange.ASX },
    { code: "ATBHI", exchange: Exchange.ASX },
    { code: "ATBHJ", exchange: Exchange.ASX },
    { code: "ATBHK", exchange: Exchange.ASX },
    { code: "ATBHL", exchange: Exchange.ASX },
    { code: "ATBHM", exchange: Exchange.ASX },
    { code: "ATBHN", exchange: Exchange.ASX },
    { code: "ATBHO", exchange: Exchange.ASX },
    { code: "ATBHP", exchange: Exchange.ASX },
    { code: "ATBHQ", exchange: Exchange.ASX },
    { code: "AXJHA", exchange: Exchange.ASX },
    { code: "AXJHB", exchange: Exchange.ASX },
    { code: "AYUHC", exchange: Exchange.ASX },
    { code: "AYUHD", exchange: Exchange.ASX },
    { code: "AYUHE", exchange: Exchange.ASX },
    { code: "B01HA", exchange: Exchange.ASX },
    { code: "B01HB", exchange: Exchange.ASX },
    { code: "B01HC", exchange: Exchange.ASX },
    { code: "B01HD", exchange: Exchange.ASX },
    { code: "B01HE", exchange: Exchange.ASX },
    { code: "B01HF", exchange: Exchange.ASX },
    { code: "B01HG", exchange: Exchange.ASX },
    { code: "B01HH", exchange: Exchange.ASX },
    { code: "BA2HA", exchange: Exchange.ASX },
    { code: "BDXHA", exchange: Exchange.ASX },
    { code: "BKCHA", exchange: Exchange.ASX },
    { code: "BNJHA", exchange: Exchange.ASX },
    { code: "BNJHB", exchange: Exchange.ASX },
    { code: "BP1HA", exchange: Exchange.ASX },
    { code: "BP1HB", exchange: Exchange.ASX },
    { code: "BPBHA", exchange: Exchange.ASX },
    { code: "BPBHB", exchange: Exchange.ASX },
    { code: "BS1HA", exchange: Exchange.ASX },
    { code: "BS1HB", exchange: Exchange.ASX },
    { code: "C2FHA", exchange: Exchange.ASX },
    { code: "CBAHAA", exchange: Exchange.ASX },
    { code: "CBAHAB", exchange: Exchange.ASX },
    { code: "CBAHAC", exchange: Exchange.ASX },
    { code: "CBAHAD", exchange: Exchange.ASX },
    { code: "CBAHAE", exchange: Exchange.ASX },
    { code: "CBAHAF", exchange: Exchange.ASX },
    { code: "CBAHAG", exchange: Exchange.ASX },
    { code: "CBAHAH", exchange: Exchange.ASX },
    { code: "CBAHAI", exchange: Exchange.ASX },
    { code: "CBAHAJ", exchange: Exchange.ASX },
    { code: "CBAHAK", exchange: Exchange.ASX },
    { code: "CBAHAL", exchange: Exchange.ASX },
    { code: "CBAHAM", exchange: Exchange.ASX },
    { code: "CBAHAN", exchange: Exchange.ASX },
    { code: "CBAHAO", exchange: Exchange.ASX },
    { code: "CBAHAP", exchange: Exchange.ASX },
    { code: "CBAHAQ", exchange: Exchange.ASX },
    { code: "CBAHU", exchange: Exchange.ASX },
    { code: "CBAHV", exchange: Exchange.ASX },
    { code: "CBAHW", exchange: Exchange.ASX },
    { code: "CBAHX", exchange: Exchange.ASX },
    { code: "CBAHY", exchange: Exchange.ASX },
    { code: "CBAHZ", exchange: Exchange.ASX },
    { code: "CCBHA", exchange: Exchange.ASX },
    { code: "CCBHB", exchange: Exchange.ASX },
    { code: "CCBHC", exchange: Exchange.ASX },
    { code: "CCLHA", exchange: Exchange.ASX },
    { code: "CCLHB", exchange: Exchange.ASX },
    { code: "CCLHC", exchange: Exchange.ASX },
    { code: "CFFHB", exchange: Exchange.ASX },
    { code: "CFFHC", exchange: Exchange.ASX },
    { code: "CHJHB", exchange: Exchange.ASX },
    { code: "CHJHC", exchange: Exchange.ASX },
    { code: "CHJHD", exchange: Exchange.ASX },
    { code: "CHJHE", exchange: Exchange.ASX },
    { code: "CHUHA", exchange: Exchange.ASX },
    { code: "CHUHB", exchange: Exchange.ASX },
    { code: "CHUHC", exchange: Exchange.ASX },
    { code: "CNUHA", exchange: Exchange.ASX },
    { code: "CNUHB", exchange: Exchange.ASX },
    { code: "CNUHC", exchange: Exchange.ASX },
    { code: "CPLHA", exchange: Exchange.ASX },
    { code: "CPLHB", exchange: Exchange.ASX },
    { code: "CPLHC", exchange: Exchange.ASX },
    { code: "CPLHD", exchange: Exchange.ASX },
    { code: "CPLHE", exchange: Exchange.ASX },
    { code: "CPLHF", exchange: Exchange.ASX },
    { code: "CPLHG", exchange: Exchange.ASX },
    { code: "CPLHH", exchange: Exchange.ASX },
    { code: "CRIHA", exchange: Exchange.ASX },
    { code: "CSNHA", exchange: Exchange.ASX },
    { code: "CSNHB", exchange: Exchange.ASX },
    { code: "CTHHA", exchange: Exchange.ASX },
    { code: "CTHHB", exchange: Exchange.ASX },
    { code: "CTJHA", exchange: Exchange.ASX },
    { code: "CTKHA", exchange: Exchange.ASX },
    { code: "CTKHB", exchange: Exchange.ASX },
    { code: "CTUHA", exchange: Exchange.ASX },
    { code: "CTUHB", exchange: Exchange.ASX },
    { code: "CU1HA", exchange: Exchange.ASX },
    { code: "CU2HA", exchange: Exchange.ASX },
    { code: "CUFHA", exchange: Exchange.ASX },
    { code: "CUHHA", exchange: Exchange.ASX },
    { code: "CVCHA", exchange: Exchange.ASX },
    { code: "DA1HA", exchange: Exchange.ASX },
    { code: "DA1HB", exchange: Exchange.ASX },
    { code: "DA8HA", exchange: Exchange.ASX },
    { code: "DA8HB", exchange: Exchange.ASX },
    { code: "DA9HA", exchange: Exchange.ASX },
    { code: "DA9HB", exchange: Exchange.ASX },
    { code: "DAEHA", exchange: Exchange.ASX },
    { code: "DAEHB", exchange: Exchange.ASX },
    { code: "DAMHA", exchange: Exchange.ASX },
    { code: "DAMHB", exchange: Exchange.ASX },
    { code: "DAMHC", exchange: Exchange.ASX },
    { code: "DAMHD", exchange: Exchange.ASX },
    { code: "DAMHE", exchange: Exchange.ASX },
    { code: "DAMHF", exchange: Exchange.ASX },
    { code: "DAMHG", exchange: Exchange.ASX },
    { code: "DAMHH", exchange: Exchange.ASX },
    { code: "DAMHI", exchange: Exchange.ASX },
    { code: "DAMHJ", exchange: Exchange.ASX },
    { code: "DAMHK", exchange: Exchange.ASX },
    { code: "DAOHA", exchange: Exchange.ASX },
    { code: "DAOHB", exchange: Exchange.ASX },
    { code: "DAQHA", exchange: Exchange.ASX },
    { code: "DAQHB", exchange: Exchange.ASX },
    { code: "DASHA", exchange: Exchange.ASX },
    { code: "DASHB", exchange: Exchange.ASX },
    { code: "DATHA", exchange: Exchange.ASX },
    { code: "DATHB", exchange: Exchange.ASX },
    { code: "DAZHA", exchange: Exchange.ASX },
    { code: "DAZHB", exchange: Exchange.ASX },
    { code: "DBNHA", exchange: Exchange.ASX },
    { code: "DGFHA", exchange: Exchange.ASX },
    { code: "DW8HA", exchange: Exchange.ASX },
    { code: "DXAHB", exchange: Exchange.ASX },
    { code: "DXAHH", exchange: Exchange.ASX },
    { code: "EMIHA", exchange: Exchange.ASX },
    { code: "EMIHB", exchange: Exchange.ASX },
    { code: "EMIHC", exchange: Exchange.ASX },
    { code: "FA1HA", exchange: Exchange.ASX },
    { code: "FA1HB", exchange: Exchange.ASX },
    { code: "FA2HA", exchange: Exchange.ASX },
    { code: "FM1HA", exchange: Exchange.ASX },
    { code: "FM2HA", exchange: Exchange.ASX },
    { code: "FM2HB", exchange: Exchange.ASX },
    { code: "FM3HA", exchange: Exchange.ASX },
    { code: "FM4HA", exchange: Exchange.ASX },
    { code: "FM4HB", exchange: Exchange.ASX },
    { code: "FM4HC", exchange: Exchange.ASX },
    { code: "FM4HD", exchange: Exchange.ASX },
    { code: "FM5HA", exchange: Exchange.ASX },
    { code: "FMAHA", exchange: Exchange.ASX },
    { code: "FMBHA", exchange: Exchange.ASX },
    { code: "FMMHA", exchange: Exchange.ASX },
    { code: "FMNHA", exchange: Exchange.ASX },
    { code: "FOBHA", exchange: Exchange.ASX },
    { code: "GSBA18", exchange: Exchange.ASX },
    { code: "GSBC17", exchange: Exchange.ASX },
    { code: "GSBE19", exchange: Exchange.ASX },
    { code: "GSBE47", exchange: Exchange.ASX },
    { code: "GSBG15", exchange: Exchange.ASX },
    { code: "GSBG20", exchange: Exchange.ASX },
    { code: "GSBG23", exchange: Exchange.ASX },
    { code: "GSBG24", exchange: Exchange.ASX },
    { code: "GSBG25", exchange: Exchange.ASX },
    { code: "GSBG26", exchange: Exchange.ASX },
    { code: "GSBG27", exchange: Exchange.ASX },
    { code: "GSBG29", exchange: Exchange.ASX },
    { code: "GSBG33", exchange: Exchange.ASX },
    { code: "GSBG37", exchange: Exchange.ASX },
    { code: "GSBI21", exchange: Exchange.ASX },
    { code: "GSBI28", exchange: Exchange.ASX },
    { code: "GSBI30", exchange: Exchange.ASX },
    { code: "GSBI32", exchange: Exchange.ASX },
    { code: "GSBI34", exchange: Exchange.ASX },
    { code: "GSBI41", exchange: Exchange.ASX },
    { code: "GSBK14", exchange: Exchange.ASX },
    { code: "GSBK16", exchange: Exchange.ASX },
    { code: "GSBK31", exchange: Exchange.ASX },
    { code: "GSBK35", exchange: Exchange.ASX },
    { code: "GSBK39", exchange: Exchange.ASX },
    { code: "GSBK51", exchange: Exchange.ASX },
    { code: "GSBK54", exchange: Exchange.ASX },
    { code: "GSBM17", exchange: Exchange.ASX },
    { code: "GSBM22", exchange: Exchange.ASX },
    { code: "GSBQ26", exchange: Exchange.ASX },
    { code: "GSBS14", exchange: Exchange.ASX },
    { code: "GSBS15", exchange: Exchange.ASX },
    { code: "GSBS18", exchange: Exchange.ASX },
    { code: "GSBS19", exchange: Exchange.ASX },
    { code: "GSBU20", exchange: Exchange.ASX },
    { code: "GSBU22", exchange: Exchange.ASX },
    { code: "GSBU24", exchange: Exchange.ASX },
    { code: "GSBU25", exchange: Exchange.ASX },
    { code: "GSBU27", exchange: Exchange.ASX },
    { code: "GSBU28", exchange: Exchange.ASX },
    { code: "GSBU29", exchange: Exchange.ASX },
    { code: "GSBU31", exchange: Exchange.ASX },
    { code: "GSBU32", exchange: Exchange.ASX },
    { code: "GSBU33", exchange: Exchange.ASX },
    { code: "GSBW13", exchange: Exchange.ASX },
    { code: "GSBW21", exchange: Exchange.ASX },
    { code: "GSBW30", exchange: Exchange.ASX },
    { code: "GSBW34", exchange: Exchange.ASX },
    { code: "GSBW35", exchange: Exchange.ASX },
    { code: "GSIC22", exchange: Exchange.ASX },
    { code: "GSIC50", exchange: Exchange.ASX },
    { code: "GSIO20", exchange: Exchange.ASX },
    { code: "GSIO35", exchange: Exchange.ASX },
    { code: "GSIO40", exchange: Exchange.ASX },
    { code: "GSIQ25", exchange: Exchange.ASX },
    { code: "GSIQ30", exchange: Exchange.ASX },
    { code: "GSIU18", exchange: Exchange.ASX },
    { code: "GSIU27", exchange: Exchange.ASX },
    { code: "GSIU32", exchange: Exchange.ASX },
    { code: "HAUHA", exchange: Exchange.ASX },
    { code: "HAUHB", exchange: Exchange.ASX },
    { code: "HAUHC", exchange: Exchange.ASX },
    { code: "HAUHD", exchange: Exchange.ASX },
    { code: "HAUHE", exchange: Exchange.ASX },
    { code: "HAUHF", exchange: Exchange.ASX },
    { code: "HBSHB", exchange: Exchange.ASX },
    { code: "HCSHA", exchange: Exchange.ASX },
    { code: "HCSHB", exchange: Exchange.ASX },
    { code: "HCSHC", exchange: Exchange.ASX },
    { code: "HCSHD", exchange: Exchange.ASX },
    { code: "HCSHE", exchange: Exchange.ASX },
    { code: "HCSHF", exchange: Exchange.ASX },
    { code: "HESHA", exchange: Exchange.ASX },
    { code: "HMIHA", exchange: Exchange.ASX },
    { code: "HTBHA", exchange: Exchange.ASX },
    { code: "HTBHB", exchange: Exchange.ASX },
    { code: "HTRHA", exchange: Exchange.ASX },
    { code: "HTVHA", exchange: Exchange.ASX },
    { code: "HYPHB", exchange: Exchange.ASX },
    { code: "ICBHA", exchange: Exchange.ASX },
    { code: "ICBHB", exchange: Exchange.ASX },
    { code: "ICBHC", exchange: Exchange.ASX },
    { code: "ICBHD", exchange: Exchange.ASX },
    { code: "ICBHE", exchange: Exchange.ASX },
    { code: "IDFHA", exchange: Exchange.ASX },
    { code: "IDFHB", exchange: Exchange.ASX },
    { code: "IDHHA", exchange: Exchange.ASX },
    { code: "IDHHB", exchange: Exchange.ASX },
    { code: "IDHHC", exchange: Exchange.ASX },
    { code: "IDJHA", exchange: Exchange.ASX },
    { code: "IDJHB", exchange: Exchange.ASX },
    { code: "IDJHC", exchange: Exchange.ASX },
    { code: "IDJHD", exchange: Exchange.ASX },
    { code: "IDJHE", exchange: Exchange.ASX },
    { code: "IDJHF", exchange: Exchange.ASX },
    { code: "IFXHC", exchange: Exchange.ASX },
    { code: "IFXHD", exchange: Exchange.ASX },
    { code: "IFXHE", exchange: Exchange.ASX },
    { code: "IFXHF", exchange: Exchange.ASX },
    { code: "IFXHG", exchange: Exchange.ASX },
    { code: "IFXHH", exchange: Exchange.ASX },
    { code: "IFXHI", exchange: Exchange.ASX },
    { code: "IFXHJ", exchange: Exchange.ASX },
    { code: "IFXHK", exchange: Exchange.ASX },
    { code: "IFXHL", exchange: Exchange.ASX },
    { code: "IFXHM", exchange: Exchange.ASX },
    { code: "ILAHA", exchange: Exchange.ASX },
    { code: "ILWHA", exchange: Exchange.ASX },
    { code: "IMGHA", exchange: Exchange.ASX },
    { code: "IMGHB", exchange: Exchange.ASX },
    { code: "IMKHA", exchange: Exchange.ASX },
    { code: "IMKHB", exchange: Exchange.ASX },
    { code: "IMKHC", exchange: Exchange.ASX },
    { code: "IMNHC", exchange: Exchange.ASX },
    { code: "IMNHD", exchange: Exchange.ASX },
    { code: "IMNHE", exchange: Exchange.ASX },
    { code: "IMOHA", exchange: Exchange.ASX },
    { code: "IMOHB", exchange: Exchange.ASX },
    { code: "IMOHC", exchange: Exchange.ASX },
    { code: "IMQHA", exchange: Exchange.ASX },
    { code: "IMQHB", exchange: Exchange.ASX },
    { code: "IMQHC", exchange: Exchange.ASX },
    { code: "IMQHD", exchange: Exchange.ASX },
    { code: "IMXHA", exchange: Exchange.ASX },
    { code: "IMXHB", exchange: Exchange.ASX },
    { code: "IMXHC", exchange: Exchange.ASX },
    { code: "IMXHD", exchange: Exchange.ASX },
    { code: "INBHA", exchange: Exchange.ASX },
    { code: "INBHB", exchange: Exchange.ASX },
    { code: "INBHC", exchange: Exchange.ASX },
    { code: "INBHD", exchange: Exchange.ASX },
    { code: "INHHB", exchange: Exchange.ASX },
    { code: "INHHC", exchange: Exchange.ASX },
    { code: "INHHD", exchange: Exchange.ASX },
    { code: "INNHB", exchange: Exchange.ASX },
    { code: "INNHC", exchange: Exchange.ASX },
    { code: "INNHD", exchange: Exchange.ASX },
    { code: "KA1HA", exchange: Exchange.ASX },
    { code: "KA1HB", exchange: Exchange.ASX },
    { code: "KEBHA", exchange: Exchange.ASX },
    { code: "KFWHAA", exchange: Exchange.ASX },
    { code: "KFWHAB", exchange: Exchange.ASX },
    { code: "KFWHAC", exchange: Exchange.ASX },
    { code: "KFWHAD", exchange: Exchange.ASX },
    { code: "KFWHAE", exchange: Exchange.ASX },
    { code: "KFWHAF", exchange: Exchange.ASX },
    { code: "KFWHAG", exchange: Exchange.ASX },
    { code: "KFWHAH", exchange: Exchange.ASX },
    { code: "KFWHAI", exchange: Exchange.ASX },
    { code: "KFWHAJ", exchange: Exchange.ASX },
    { code: "KFWHAK", exchange: Exchange.ASX },
    { code: "KFWHAL", exchange: Exchange.ASX },
    { code: "KFWHE", exchange: Exchange.ASX },
    { code: "KFWHH", exchange: Exchange.ASX },
    { code: "KFWHK", exchange: Exchange.ASX },
    { code: "KFWHN", exchange: Exchange.ASX },
    { code: "KFWHO", exchange: Exchange.ASX },
    { code: "KFWHP", exchange: Exchange.ASX },
    { code: "KFWHQ", exchange: Exchange.ASX },
    { code: "KFWHR", exchange: Exchange.ASX },
    { code: "KFWHS", exchange: Exchange.ASX },
    { code: "KFWHU", exchange: Exchange.ASX },
    { code: "KFWHV", exchange: Exchange.ASX },
    { code: "KFWHW", exchange: Exchange.ASX },
    { code: "KFWHX", exchange: Exchange.ASX },
    { code: "KFWHY", exchange: Exchange.ASX },
    { code: "KFWHZ", exchange: Exchange.ASX },
    { code: "KI1HA", exchange: Exchange.ASX },
    { code: "KI1HB", exchange: Exchange.ASX },
    { code: "KIGHA", exchange: Exchange.ASX },
    { code: "KIGHB", exchange: Exchange.ASX },
    { code: "KISHA", exchange: Exchange.ASX },
    { code: "KISHB", exchange: Exchange.ASX },
    { code: "KKOHA", exchange: Exchange.ASX },
    { code: "KOPHA", exchange: Exchange.ASX },
    { code: "LC1HA", exchange: Exchange.ASX },
    { code: "LC2HA", exchange: Exchange.ASX },
    { code: "LCNHA", exchange: Exchange.ASX },
    { code: "LCNHB", exchange: Exchange.ASX },
    { code: "LCNHC", exchange: Exchange.ASX },
    { code: "LCNHD", exchange: Exchange.ASX },
    { code: "LCNHE", exchange: Exchange.ASX },
    { code: "LCNHF", exchange: Exchange.ASX },
    { code: "LCNHG", exchange: Exchange.ASX },
    { code: "LCNHH", exchange: Exchange.ASX },
    { code: "LCNHI", exchange: Exchange.ASX },
    { code: "LCNHJ", exchange: Exchange.ASX },
    { code: "LCNHK", exchange: Exchange.ASX },
    { code: "LI1HA", exchange: Exchange.ASX },
    { code: "LI2HA", exchange: Exchange.ASX },
    { code: "LI2HB", exchange: Exchange.ASX },
    { code: "LI4HA", exchange: Exchange.ASX },
    { code: "LI5HA", exchange: Exchange.ASX },
    { code: "LI5HB", exchange: Exchange.ASX },
    { code: "LI6HA", exchange: Exchange.ASX },
    { code: "LI7HA", exchange: Exchange.ASX },
    { code: "LI7HB", exchange: Exchange.ASX },
    { code: "LI7HC", exchange: Exchange.ASX },
    { code: "LI8HA", exchange: Exchange.ASX },
    { code: "LI8HB", exchange: Exchange.ASX },
    { code: "LI9HA", exchange: Exchange.ASX },
    { code: "LI9HB", exchange: Exchange.ASX },
    { code: "LLPPA", exchange: Exchange.ASX },
    { code: "LLPPB", exchange: Exchange.ASX },
    { code: "LN1HA", exchange: Exchange.ASX },
    { code: "LN1HB", exchange: Exchange.ASX },
    { code: "LN2HA", exchange: Exchange.ASX },
    { code: "LN2HB", exchange: Exchange.ASX },
    { code: "LN3HA", exchange: Exchange.ASX },
    { code: "LN3HB", exchange: Exchange.ASX },
    { code: "LN3HC", exchange: Exchange.ASX },
    { code: "LNSHA", exchange: Exchange.ASX },
    { code: "LO1HA", exchange: Exchange.ASX },
    { code: "LO1HB", exchange: Exchange.ASX },
    { code: "LO1PA", exchange: Exchange.ASX },
    { code: "LO1PB", exchange: Exchange.ASX },
    { code: "LO1PC", exchange: Exchange.ASX },
    { code: "LO1PD", exchange: Exchange.ASX },
    { code: "LO1PE", exchange: Exchange.ASX },
    { code: "LO1PF", exchange: Exchange.ASX },
    { code: "LO1PG", exchange: Exchange.ASX },
    { code: "LO1PH", exchange: Exchange.ASX },
    { code: "LO1PI", exchange: Exchange.ASX },
    { code: "LO1PJ", exchange: Exchange.ASX },
    { code: "LO1PK", exchange: Exchange.ASX },
    { code: "LO1PL", exchange: Exchange.ASX },
    { code: "LO1PM", exchange: Exchange.ASX },
    { code: "LP1HA", exchange: Exchange.ASX },
    { code: "LP1HB", exchange: Exchange.ASX },
    { code: "LP1HC", exchange: Exchange.ASX },
    { code: "LR1HA", exchange: Exchange.ASX },
    { code: "LR1HB", exchange: Exchange.ASX },
    { code: "LR3HA", exchange: Exchange.ASX },
    { code: "LR3HB", exchange: Exchange.ASX },
    { code: "LR4HA", exchange: Exchange.ASX },
    { code: "LR4HB", exchange: Exchange.ASX },
    { code: "LR5HA", exchange: Exchange.ASX },
    { code: "LR5HB", exchange: Exchange.ASX },
    { code: "LT1HA", exchange: Exchange.ASX },
    { code: "LT1HB", exchange: Exchange.ASX },
    { code: "LT2HA", exchange: Exchange.ASX },
    { code: "LT2HB", exchange: Exchange.ASX },
    { code: "LT3HA", exchange: Exchange.ASX },
    { code: "LT3HB", exchange: Exchange.ASX },
    { code: "LT3HC", exchange: Exchange.ASX },
    { code: "LT4HA", exchange: Exchange.ASX },
    { code: "LT4HB", exchange: Exchange.ASX },
    { code: "LT4HC", exchange: Exchange.ASX },
    { code: "LT5HA", exchange: Exchange.ASX },
    { code: "LT5HB", exchange: Exchange.ASX },
    { code: "LT6HA", exchange: Exchange.ASX },
    { code: "LT6HB", exchange: Exchange.ASX },
    { code: "LT7HA", exchange: Exchange.ASX },
    { code: "LT7HB", exchange: Exchange.ASX },
    { code: "LT8HA", exchange: Exchange.ASX },
    { code: "LT8HB", exchange: Exchange.ASX },
    { code: "LT9HA", exchange: Exchange.ASX },
    { code: "LT9HB", exchange: Exchange.ASX },
    { code: "LTFHA", exchange: Exchange.ASX },
    { code: "LTFHB", exchange: Exchange.ASX },
    { code: "MBJHA", exchange: Exchange.ASX },
    { code: "MBLHC", exchange: Exchange.ASX },
    { code: "MDZHA", exchange: Exchange.ASX },
    { code: "MELHA", exchange: Exchange.ASX },
    { code: "MF1HA", exchange: Exchange.ASX },
    { code: "MF2HA", exchange: Exchange.ASX },
    { code: "MF3HA", exchange: Exchange.ASX },
    { code: "MF4HA", exchange: Exchange.ASX },
    { code: "MF4HB", exchange: Exchange.ASX },
    { code: "MF4HC", exchange: Exchange.ASX },
    { code: "MF4HD", exchange: Exchange.ASX },
    { code: "MF4HE", exchange: Exchange.ASX },
    { code: "MF4HF", exchange: Exchange.ASX },
    { code: "MPZHA", exchange: Exchange.ASX },
    { code: "MVTHA", exchange: Exchange.ASX },
    { code: "MZ1HA", exchange: Exchange.ASX },
    { code: "MZ1HB", exchange: Exchange.ASX },
    { code: "MZ2HA", exchange: Exchange.ASX },
    { code: "MZ2HB", exchange: Exchange.ASX },
    { code: "MZAHA", exchange: Exchange.ASX },
    { code: "MZBHA", exchange: Exchange.ASX },
    { code: "MZCHA", exchange: Exchange.ASX },
    { code: "MZFHA", exchange: Exchange.ASX },
    { code: "MZTHA", exchange: Exchange.ASX },
    { code: "NABHE", exchange: Exchange.ASX },
    { code: "NABHF", exchange: Exchange.ASX },
    { code: "NABHG", exchange: Exchange.ASX },
    { code: "NABHH", exchange: Exchange.ASX },
    { code: "NABHI", exchange: Exchange.ASX },
    { code: "NAFHA", exchange: Exchange.ASX },
    { code: "NAFHC", exchange: Exchange.ASX },
    { code: "NAHHA", exchange: Exchange.ASX },
    { code: "NAHHB", exchange: Exchange.ASX },
    { code: "NAJHA", exchange: Exchange.ASX },
    { code: "NAOHB", exchange: Exchange.ASX },
    { code: "NAOHC", exchange: Exchange.ASX },
    { code: "NBSHA", exchange: Exchange.ASX },
    { code: "NIBHD", exchange: Exchange.ASX },
    { code: "NIBHE", exchange: Exchange.ASX },
    { code: "NIBHF", exchange: Exchange.ASX },
    { code: "NIBHG", exchange: Exchange.ASX },
    { code: "NIBHH", exchange: Exchange.ASX },
    { code: "NIBHI", exchange: Exchange.ASX },
    { code: "NIBHJ", exchange: Exchange.ASX },
    { code: "NRMHA", exchange: Exchange.ASX },
    { code: "NROHA", exchange: Exchange.ASX },
    { code: "NROHB", exchange: Exchange.ASX },
    { code: "NROHC", exchange: Exchange.ASX },
    { code: "NRPHA", exchange: Exchange.ASX },
    { code: "NRPHB", exchange: Exchange.ASX },
    { code: "NRPHC", exchange: Exchange.ASX },
    { code: "NW1HA", exchange: Exchange.ASX },
    { code: "NWBHB", exchange: Exchange.ASX },
    { code: "OYSHA", exchange: Exchange.ASX },
    { code: "OYSHB", exchange: Exchange.ASX },
    { code: "PA1HA", exchange: Exchange.ASX },
    { code: "PA2HA", exchange: Exchange.ASX },
    { code: "PA2HB", exchange: Exchange.ASX },
    { code: "PA3HA", exchange: Exchange.ASX },
    { code: "PA4HA", exchange: Exchange.ASX },
    { code: "PA4HB", exchange: Exchange.ASX },
    { code: "PA4HC", exchange: Exchange.ASX },
    { code: "PA4HD", exchange: Exchange.ASX },
    { code: "PAAHA", exchange: Exchange.ASX },
    { code: "PE4HA", exchange: Exchange.ASX },
    { code: "PE4HB", exchange: Exchange.ASX },
    { code: "PE5HA", exchange: Exchange.ASX },
    { code: "PEAHA", exchange: Exchange.ASX },
    { code: "PEPHA", exchange: Exchange.ASX },
    { code: "PEPHB", exchange: Exchange.ASX },
    { code: "PEPHC", exchange: Exchange.ASX },
    { code: "PEPHD", exchange: Exchange.ASX },
    { code: "PERHA", exchange: Exchange.ASX },
    { code: "PERHB", exchange: Exchange.ASX },
    { code: "PERHC", exchange: Exchange.ASX },
    { code: "PERHD", exchange: Exchange.ASX },
    { code: "PESHA", exchange: Exchange.ASX },
    { code: "PEUHA", exchange: Exchange.ASX },
    { code: "PEUHB", exchange: Exchange.ASX },
    { code: "PEVHA", exchange: Exchange.ASX },
    { code: "PEXHA", exchange: Exchange.ASX },
    { code: "POAHA", exchange: Exchange.ASX },
    { code: "POBHA", exchange: Exchange.ASX },
    { code: "POBHB", exchange: Exchange.ASX },
    { code: "POCHA", exchange: Exchange.ASX },
    { code: "POCHB", exchange: Exchange.ASX },
    { code: "POEHA", exchange: Exchange.ASX },
    { code: "POFHA", exchange: Exchange.ASX },
    { code: "POGHA", exchange: Exchange.ASX },
    { code: "POGHB", exchange: Exchange.ASX },
    { code: "POHHA", exchange: Exchange.ASX },
    { code: "PONHA", exchange: Exchange.ASX },
    { code: "POTHA", exchange: Exchange.ASX },
    { code: "POVHA", exchange: Exchange.ASX },
    { code: "POXHA", exchange: Exchange.ASX },
    { code: "PP1HA", exchange: Exchange.ASX },
    { code: "PPCHA", exchange: Exchange.ASX },
    { code: "PPZHA", exchange: Exchange.ASX },
    { code: "PU1HA", exchange: Exchange.ASX },
    { code: "PU1HB", exchange: Exchange.ASX },
    { code: "PU2HA", exchange: Exchange.ASX },
    { code: "PU3HA", exchange: Exchange.ASX },
    { code: "PU4HA", exchange: Exchange.ASX },
    { code: "PU4HB", exchange: Exchange.ASX },
    { code: "PU6HA", exchange: Exchange.ASX },
    { code: "PU6HB", exchange: Exchange.ASX },
    { code: "PU8HA", exchange: Exchange.ASX },
    { code: "PUAHA", exchange: Exchange.ASX },
    { code: "PUAHB", exchange: Exchange.ASX },
    { code: "PUBHA", exchange: Exchange.ASX },
    { code: "PUCHA", exchange: Exchange.ASX },
    { code: "PUCHB", exchange: Exchange.ASX },
    { code: "PUCHC", exchange: Exchange.ASX },
    { code: "PUCHD", exchange: Exchange.ASX },
    { code: "PUDHA", exchange: Exchange.ASX },
    { code: "PUEHA", exchange: Exchange.ASX },
    { code: "PUEHB", exchange: Exchange.ASX },
    { code: "PUGHA", exchange: Exchange.ASX },
    { code: "PUGHB", exchange: Exchange.ASX },
    { code: "PUHHA", exchange: Exchange.ASX },
    { code: "PUHHB", exchange: Exchange.ASX },
    { code: "PUIHA", exchange: Exchange.ASX },
    { code: "PUIHB", exchange: Exchange.ASX },
    { code: "PUJHA", exchange: Exchange.ASX },
    { code: "PUKHA", exchange: Exchange.ASX },
    { code: "PUKHB", exchange: Exchange.ASX },
    { code: "PUOHA", exchange: Exchange.ASX },
    { code: "PUPHA", exchange: Exchange.ASX },
    { code: "PUPHB", exchange: Exchange.ASX },
    { code: "PUQHA", exchange: Exchange.ASX },
    { code: "PUSHA", exchange: Exchange.ASX },
    { code: "PUSHB", exchange: Exchange.ASX },
    { code: "PUTHA", exchange: Exchange.ASX },
    { code: "PUUHA", exchange: Exchange.ASX },
    { code: "PUVHA", exchange: Exchange.ASX },
    { code: "PUZHA", exchange: Exchange.ASX },
    { code: "QBCHE", exchange: Exchange.ASX },
    { code: "QBCHF", exchange: Exchange.ASX },
    { code: "QNBHA", exchange: Exchange.ASX },
    { code: "QNBHB", exchange: Exchange.ASX },
    { code: "QNBHC", exchange: Exchange.ASX },
    { code: "RA1HA", exchange: Exchange.ASX },
    { code: "RA2HA", exchange: Exchange.ASX },
    { code: "RA3HA", exchange: Exchange.ASX },
    { code: "RB1HA", exchange: Exchange.ASX },
    { code: "RDAHA", exchange: Exchange.ASX },
    { code: "RDAHB", exchange: Exchange.ASX },
    { code: "RDAHC", exchange: Exchange.ASX },
    { code: "REKHA", exchange: Exchange.ASX },
    { code: "REKHB", exchange: Exchange.ASX },
    { code: "REQHA", exchange: Exchange.ASX },
    { code: "REQHB", exchange: Exchange.ASX },
    { code: "RFAHA", exchange: Exchange.ASX },
    { code: "RFAHB", exchange: Exchange.ASX },
    { code: "RFBHA", exchange: Exchange.ASX },
    { code: "RFBHB", exchange: Exchange.ASX },
    { code: "RFBHC", exchange: Exchange.ASX },
    { code: "RFBHD", exchange: Exchange.ASX },
    { code: "RFCHA", exchange: Exchange.ASX },
    { code: "RFEHA", exchange: Exchange.ASX },
    { code: "RM1HA", exchange: Exchange.ASX },
    { code: "RM1HB", exchange: Exchange.ASX },
    { code: "RMBHA", exchange: Exchange.ASX },
    { code: "RMBHB", exchange: Exchange.ASX },
    { code: "RMBHC", exchange: Exchange.ASX },
    { code: "RMFHA", exchange: Exchange.ASX },
    { code: "RMFHB", exchange: Exchange.ASX },
    { code: "RMFHC", exchange: Exchange.ASX },
    { code: "RMHHA", exchange: Exchange.ASX },
    { code: "RMHHB", exchange: Exchange.ASX },
    { code: "RMHHC", exchange: Exchange.ASX },
    { code: "RMMHA", exchange: Exchange.ASX },
    { code: "RMMHB", exchange: Exchange.ASX },
    { code: "RMMHC", exchange: Exchange.ASX },
    { code: "ROAHA", exchange: Exchange.ASX },
    { code: "RT1HA", exchange: Exchange.ASX },
    { code: "RT2HA", exchange: Exchange.ASX },
    { code: "RT9HA", exchange: Exchange.ASX },
    { code: "RT9HB", exchange: Exchange.ASX },
    { code: "RT9HC", exchange: Exchange.ASX },
    { code: "RT9HD", exchange: Exchange.ASX },
    { code: "RT9HE", exchange: Exchange.ASX },
    { code: "RTCHA", exchange: Exchange.ASX },
    { code: "RTCHB", exchange: Exchange.ASX },
    { code: "RTCHC", exchange: Exchange.ASX },
    { code: "RTDHA", exchange: Exchange.ASX },
    { code: "RTTHA", exchange: Exchange.ASX },
    { code: "SABHA", exchange: Exchange.ASX },
    { code: "SABHB", exchange: Exchange.ASX },
    { code: "SACHA", exchange: Exchange.ASX },
    { code: "SACHB", exchange: Exchange.ASX },
    { code: "SAJHA", exchange: Exchange.ASX },
    { code: "SAZHA", exchange: Exchange.ASX },
    { code: "SC1HA", exchange: Exchange.ASX },
    { code: "SCAHA", exchange: Exchange.ASX },
    { code: "SCAHB", exchange: Exchange.ASX },
    { code: "SCAHC", exchange: Exchange.ASX },
    { code: "SCAHD", exchange: Exchange.ASX },
    { code: "SCAHE", exchange: Exchange.ASX },
    { code: "SCDHA", exchange: Exchange.ASX },
    { code: "SCDHB", exchange: Exchange.ASX },
    { code: "SCWHA", exchange: Exchange.ASX },
    { code: "SCWHB", exchange: Exchange.ASX },
    { code: "SCWHC", exchange: Exchange.ASX },
    { code: "SCWHD", exchange: Exchange.ASX },
    { code: "SFVHA", exchange: Exchange.ASX },
    { code: "SFVHB", exchange: Exchange.ASX },
    { code: "SHBHA", exchange: Exchange.ASX },
    { code: "SHZHA", exchange: Exchange.ASX },
    { code: "SHZHB", exchange: Exchange.ASX },
    { code: "SHZHC", exchange: Exchange.ASX },
    { code: "SHZHD", exchange: Exchange.ASX },
    { code: "SHZHE", exchange: Exchange.ASX },
    { code: "SHZHF", exchange: Exchange.ASX },
    { code: "SHZHG", exchange: Exchange.ASX },
    { code: "SHZHH", exchange: Exchange.ASX },
    { code: "SM9HA", exchange: Exchange.ASX },
    { code: "SMTHA", exchange: Exchange.ASX },
    { code: "SNAHB", exchange: Exchange.ASX },
    { code: "SNAHC", exchange: Exchange.ASX },
    { code: "SNCHA", exchange: Exchange.ASX },
    { code: "SP4HA", exchange: Exchange.ASX },
    { code: "SP4HB", exchange: Exchange.ASX },
    { code: "SP4HC", exchange: Exchange.ASX },
    { code: "SP5HA", exchange: Exchange.ASX },
    { code: "SP5HB", exchange: Exchange.ASX },
    { code: "SPWHA", exchange: Exchange.ASX },
    { code: "SS6HA", exchange: Exchange.ASX },
    { code: "SS7HA", exchange: Exchange.ASX },
    { code: "SSEHA", exchange: Exchange.ASX },
    { code: "SSFHA", exchange: Exchange.ASX },
    { code: "SXBHA", exchange: Exchange.ASX },
    { code: "SXBHB", exchange: Exchange.ASX },
    { code: "TA1HA", exchange: Exchange.ASX },
    { code: "TA1HB", exchange: Exchange.ASX },
    { code: "TA1HC", exchange: Exchange.ASX },
    { code: "TA1HD", exchange: Exchange.ASX },
    { code: "TESHA", exchange: Exchange.ASX },
    { code: "TL1HAA", exchange: Exchange.ASX },
    { code: "TL1HY", exchange: Exchange.ASX },
    { code: "TL1HZ", exchange: Exchange.ASX },
    { code: "TLSHAA", exchange: Exchange.ASX },
    { code: "TLSHAB", exchange: Exchange.ASX },
    { code: "TLSHX", exchange: Exchange.ASX },
    { code: "TLSHY", exchange: Exchange.ASX },
    { code: "TLSHZ", exchange: Exchange.ASX },
    { code: "TNBHA", exchange: Exchange.ASX },
    { code: "TNFHA", exchange: Exchange.ASX },
    { code: "TNHHA", exchange: Exchange.ASX },
    { code: "TNJHA", exchange: Exchange.ASX },
    { code: "TNJHB", exchange: Exchange.ASX },
    { code: "TOAHC", exchange: Exchange.ASX },
    { code: "TOAHD", exchange: Exchange.ASX },
    { code: "TOAHE", exchange: Exchange.ASX },
    { code: "TOAHF", exchange: Exchange.ASX },
    { code: "TOAHG", exchange: Exchange.ASX },
    { code: "TOZHA", exchange: Exchange.ASX },
    { code: "TRBHA", exchange: Exchange.ASX },
    { code: "TRKHA", exchange: Exchange.ASX },
    { code: "TRKHB", exchange: Exchange.ASX },
    { code: "TRKHC", exchange: Exchange.ASX },
    { code: "TRKHD", exchange: Exchange.ASX },
    { code: "TRPHA", exchange: Exchange.ASX },
    { code: "TRQHA", exchange: Exchange.ASX },
    { code: "TRQHB", exchange: Exchange.ASX },
    { code: "TRXHA", exchange: Exchange.ASX },
    { code: "TRXHB", exchange: Exchange.ASX },
    { code: "TT1HA", exchange: Exchange.ASX },
    { code: "TT1HB", exchange: Exchange.ASX },
    { code: "TT1HC", exchange: Exchange.ASX },
    { code: "TT1HD", exchange: Exchange.ASX },
    { code: "TT2HA", exchange: Exchange.ASX },
    { code: "TT2HB", exchange: Exchange.ASX },
    { code: "TT2HC", exchange: Exchange.ASX },
    { code: "TT2HD", exchange: Exchange.ASX },
    { code: "TT3HA", exchange: Exchange.ASX },
    { code: "TT3HB", exchange: Exchange.ASX },
    { code: "TT3HC", exchange: Exchange.ASX },
    { code: "TT3HD", exchange: Exchange.ASX },
    { code: "TT4HA", exchange: Exchange.ASX },
    { code: "TT4HB", exchange: Exchange.ASX },
    { code: "TT4HC", exchange: Exchange.ASX },
    { code: "TT4HD", exchange: Exchange.ASX },
    { code: "TT4HE", exchange: Exchange.ASX },
    { code: "TT5HA", exchange: Exchange.ASX },
    { code: "TT5HB", exchange: Exchange.ASX },
    { code: "TT5HC", exchange: Exchange.ASX },
    { code: "TT5HD", exchange: Exchange.ASX },
    { code: "TT6HA", exchange: Exchange.ASX },
    { code: "TT6HB", exchange: Exchange.ASX },
    { code: "TT6HC", exchange: Exchange.ASX },
    { code: "TT6HD", exchange: Exchange.ASX },
    { code: "TT7HA", exchange: Exchange.ASX },
    { code: "TT7HB", exchange: Exchange.ASX },
    { code: "TT7HC", exchange: Exchange.ASX },
    { code: "TT9HA", exchange: Exchange.ASX },
    { code: "TT9HB", exchange: Exchange.ASX },
    { code: "TT9HC", exchange: Exchange.ASX },
    { code: "TT9HD", exchange: Exchange.ASX },
    { code: "TT9HE", exchange: Exchange.ASX },
    { code: "TTZHA", exchange: Exchange.ASX },
    { code: "URFHA", exchange: Exchange.ASX },
    { code: "URFHB", exchange: Exchange.ASX },
    { code: "URFHC", exchange: Exchange.ASX },
    { code: "VAHHA", exchange: Exchange.ASX },
    { code: "VBCHA", exchange: Exchange.ASX },
    { code: "VCDHA", exchange: Exchange.ASX },
    { code: "VCDHB", exchange: Exchange.ASX },
    { code: "VPGHA", exchange: Exchange.ASX },
    { code: "VPGHB", exchange: Exchange.ASX },
    { code: "VPGHC", exchange: Exchange.ASX },
    { code: "VT1HA", exchange: Exchange.ASX },
    { code: "VT2HA", exchange: Exchange.ASX },
    { code: "VT2HB", exchange: Exchange.ASX },
    { code: "WB1HA", exchange: Exchange.ASX },
    { code: "WB2HA", exchange: Exchange.ASX },
    { code: "WB2HB", exchange: Exchange.ASX },
    { code: "WBCHAL", exchange: Exchange.ASX },
    { code: "WBCHAM", exchange: Exchange.ASX },
    { code: "WBCHAP", exchange: Exchange.ASX },
    { code: "WBCHAQ", exchange: Exchange.ASX },
    { code: "WBCHAS", exchange: Exchange.ASX },
    { code: "WBCHAT", exchange: Exchange.ASX },
    { code: "WBCHAU", exchange: Exchange.ASX },
    { code: "WBCHAV", exchange: Exchange.ASX },
    { code: "WBCHAW", exchange: Exchange.ASX },
    { code: "WBCHAX", exchange: Exchange.ASX },
    { code: "WBCHAY", exchange: Exchange.ASX },
    { code: "WBCHAZ", exchange: Exchange.ASX },
    { code: "WBCHBA", exchange: Exchange.ASX },
    { code: "WBCHBB", exchange: Exchange.ASX },
    { code: "WBCHBC", exchange: Exchange.ASX },
    { code: "WBCHBD", exchange: Exchange.ASX },
    { code: "WBCHBE", exchange: Exchange.ASX },
    { code: "WBCHBF", exchange: Exchange.ASX },
    { code: "WBCHBG", exchange: Exchange.ASX },
    { code: "WBCHBH", exchange: Exchange.ASX },
    { code: "WBCHBI", exchange: Exchange.ASX },
    { code: "WBCHBJ", exchange: Exchange.ASX },
    { code: "WBCHBK", exchange: Exchange.ASX },
    { code: "WBCHBL", exchange: Exchange.ASX },
    { code: "WBCHBM", exchange: Exchange.ASX },
    { code: "WBCHBN", exchange: Exchange.ASX },
    { code: "WBCHBO", exchange: Exchange.ASX },
    { code: "WBCHBP", exchange: Exchange.ASX },
    { code: "WBCHBQ", exchange: Exchange.ASX },
    { code: "WBCHBR", exchange: Exchange.ASX },
    { code: "WBCHBS", exchange: Exchange.ASX },
    { code: "WBCHBT", exchange: Exchange.ASX },
    { code: "WBCHBU", exchange: Exchange.ASX },
    { code: "WBCHBV", exchange: Exchange.ASX },
    { code: "WBCHBW", exchange: Exchange.ASX },
    { code: "WBCHBX", exchange: Exchange.ASX },
    { code: "WBCHBY", exchange: Exchange.ASX },
    { code: "WBCHBZ", exchange: Exchange.ASX },
    { code: "WBCHCA", exchange: Exchange.ASX },
    { code: "WBCHCB", exchange: Exchange.ASX },
    { code: "WBCHCC", exchange: Exchange.ASX },
    { code: "WBCHCD", exchange: Exchange.ASX },
    { code: "WBCHCE", exchange: Exchange.ASX },
    { code: "WBCHCF", exchange: Exchange.ASX },
    { code: "WBCHCG", exchange: Exchange.ASX },
    { code: "WBCHCH", exchange: Exchange.ASX },
    { code: "WBCHCI", exchange: Exchange.ASX },
    { code: "WBCHCJ", exchange: Exchange.ASX },
    { code: "WBCHCK", exchange: Exchange.ASX },
    { code: "WBCHCL", exchange: Exchange.ASX },
    { code: "WBCHCM", exchange: Exchange.ASX },
    { code: "WBCHCN", exchange: Exchange.ASX },
    { code: "WBCHCO", exchange: Exchange.ASX },
    { code: "WBCHCP", exchange: Exchange.ASX },
    { code: "WBCHCQ", exchange: Exchange.ASX },
    { code: "WBCHCR", exchange: Exchange.ASX },
    { code: "WBCHCS", exchange: Exchange.ASX },
    { code: "WBCHCT", exchange: Exchange.ASX },
    { code: "WBCHCU", exchange: Exchange.ASX },
    { code: "WBCHCV", exchange: Exchange.ASX },
    { code: "WBCHCW", exchange: Exchange.ASX },
    { code: "WBCHCX", exchange: Exchange.ASX },
    { code: "WBCHCY", exchange: Exchange.ASX },
    { code: "WBCHCZ", exchange: Exchange.ASX },
    { code: "WBCHDA", exchange: Exchange.ASX },
    { code: "WBCHDB", exchange: Exchange.ASX },
    { code: "WBCHDC", exchange: Exchange.ASX },
    { code: "WBCHDD", exchange: Exchange.ASX },
    { code: "WBCHDE", exchange: Exchange.ASX },
    { code: "WBCHDF", exchange: Exchange.ASX },
    { code: "WBCHDG", exchange: Exchange.ASX },
    { code: "WE1HA", exchange: Exchange.ASX },
    { code: "WEFHA", exchange: Exchange.ASX },
    { code: "WEFHB", exchange: Exchange.ASX },
    { code: "WEFHC", exchange: Exchange.ASX },
    { code: "WEFHD", exchange: Exchange.ASX },
    { code: "WEFHE", exchange: Exchange.ASX },
    { code: "WEHHA", exchange: Exchange.ASX },
    { code: "WEJHA", exchange: Exchange.ASX },
    { code: "WEKHA", exchange: Exchange.ASX },
    { code: "WENHA", exchange: Exchange.ASX },
    { code: "WENHB", exchange: Exchange.ASX },
    { code: "WS1HA", exchange: Exchange.ASX },
    { code: "WSCHA", exchange: Exchange.ASX },
    { code: "WSDHA", exchange: Exchange.ASX },
    { code: "WSEHA", exchange: Exchange.ASX },
    { code: "WSHHA", exchange: Exchange.ASX },
    { code: "WSJHA", exchange: Exchange.ASX },
    { code: "WSNHA", exchange: Exchange.ASX },
    { code: "WSOHA", exchange: Exchange.ASX },
    { code: "WSQHA", exchange: Exchange.ASX },
    { code: "WSZHA", exchange: Exchange.ASX },
    { code: "XCLWAA", exchange: Exchange.ASX },
    { code: "XCLWAC", exchange: Exchange.ASX },
    { code: "XCLWAD", exchange: Exchange.ASX },
    { code: "XCLWAE", exchange: Exchange.ASX },
    { code: "XCLWAF", exchange: Exchange.ASX },
    { code: "XCLWAG", exchange: Exchange.ASX },
    { code: "XCLWAI", exchange: Exchange.ASX },
    { code: "XCLWAL", exchange: Exchange.ASX },
    { code: "XCLWAM", exchange: Exchange.ASX },
    { code: "XCLWAO", exchange: Exchange.ASX },
    { code: "XCLWAP", exchange: Exchange.ASX },
    { code: "XCLWAQ", exchange: Exchange.ASX },
    { code: "XCLWAR", exchange: Exchange.ASX },
    { code: "XCLWAS", exchange: Exchange.ASX },
    { code: "XCLWAU", exchange: Exchange.ASX },
    { code: "XCLWAV", exchange: Exchange.ASX },
    { code: "XCLWAX", exchange: Exchange.ASX },
    { code: "XCLWAY", exchange: Exchange.ASX },
    { code: "XCLWAZ", exchange: Exchange.ASX },
    { code: "XCLWBA", exchange: Exchange.ASX },
    { code: "XCLWBB", exchange: Exchange.ASX },
    { code: "XCLWBC", exchange: Exchange.ASX },
    { code: "XCLWBD", exchange: Exchange.ASX },
    { code: "XCLWBE", exchange: Exchange.ASX },
    { code: "XCLWBF", exchange: Exchange.ASX },
    { code: "XCLWBG", exchange: Exchange.ASX },
    { code: "XCLWBH", exchange: Exchange.ASX },
    { code: "XCLWBI", exchange: Exchange.ASX },
    { code: "XCLWBJ", exchange: Exchange.ASX },
    { code: "XCLWBK", exchange: Exchange.ASX },
    { code: "XCLWBL", exchange: Exchange.ASX },
    { code: "XCLWBM", exchange: Exchange.ASX },
    { code: "XCLWBN", exchange: Exchange.ASX },
    { code: "XCLWBO", exchange: Exchange.ASX },
    { code: "XCLWBP", exchange: Exchange.ASX },
    { code: "XCLWP", exchange: Exchange.ASX },
    { code: "XCLWV", exchange: Exchange.ASX },
    { code: "XNCHB", exchange: Exchange.ASX },
    { code: "XQLQAA", exchange: Exchange.ASX },
    { code: "XQLQAB", exchange: Exchange.ASX },
    { code: "XQLQAC", exchange: Exchange.ASX },
    { code: "XQLQAD", exchange: Exchange.ASX },
    { code: "XQLQAE", exchange: Exchange.ASX },
    { code: "XQLQAF", exchange: Exchange.ASX },
    { code: "XQLQAG", exchange: Exchange.ASX },
    { code: "XQLQAH", exchange: Exchange.ASX },
    { code: "XQLQAI", exchange: Exchange.ASX },
    { code: "XQLQAJ", exchange: Exchange.ASX },
    { code: "XQLQAK", exchange: Exchange.ASX },
    { code: "XQLQAL", exchange: Exchange.ASX },
    { code: "XQLQAM", exchange: Exchange.ASX },
    { code: "XQLQAN", exchange: Exchange.ASX },
    { code: "XQLQAO", exchange: Exchange.ASX },
    { code: "XQLQAP", exchange: Exchange.ASX },
    { code: "XQLQAQ", exchange: Exchange.ASX },
    { code: "XQLQAR", exchange: Exchange.ASX },
    { code: "XQLQG", exchange: Exchange.ASX },
    { code: "XQLQI", exchange: Exchange.ASX },
    { code: "XQLQU", exchange: Exchange.ASX },
    { code: "XVGAK", exchange: Exchange.ASX },
    { code: "XVGHAA", exchange: Exchange.ASX },
    { code: "XVGHAB", exchange: Exchange.ASX },
    { code: "XVGHAC", exchange: Exchange.ASX },
    { code: "XVGHAD", exchange: Exchange.ASX },
    { code: "XVGHAE", exchange: Exchange.ASX },
    { code: "XVGHAF", exchange: Exchange.ASX },
    { code: "XVGHAG", exchange: Exchange.ASX },
    { code: "XVGHAH", exchange: Exchange.ASX },
    { code: "XVGHAI", exchange: Exchange.ASX },
    { code: "XVGHAJ", exchange: Exchange.ASX },
    { code: "XVGHAK", exchange: Exchange.ASX },
    { code: "XVGHD", exchange: Exchange.ASX },
    { code: "XVGHF", exchange: Exchange.ASX },
    { code: "XVGHH", exchange: Exchange.ASX },
    { code: "XVGHI", exchange: Exchange.ASX },
    { code: "XVGHJ", exchange: Exchange.ASX },
    { code: "XVGHL", exchange: Exchange.ASX },
    { code: "XVGHN", exchange: Exchange.ASX },
    { code: "XVGHO", exchange: Exchange.ASX },
    { code: "XVGHQ", exchange: Exchange.ASX },
    { code: "XVGHR", exchange: Exchange.ASX },
    { code: "XVGHS", exchange: Exchange.ASX },
    { code: "XVGHT", exchange: Exchange.ASX },
    { code: "XVGHU", exchange: Exchange.ASX },
    { code: "XVGHV", exchange: Exchange.ASX },
    { code: "XVGHW", exchange: Exchange.ASX },
    { code: "XVGHX", exchange: Exchange.ASX },
    { code: "XVGHY", exchange: Exchange.ASX },
    { code: "XVGHZ", exchange: Exchange.ASX },
    { code: "XVGZB", exchange: Exchange.ASX },
    { code: "XVGZC", exchange: Exchange.ASX },
    { code: "XVGZI", exchange: Exchange.ASX },
    { code: "ZZAABC", exchange: Exchange.AOM },
    { code: "ZZACDE", exchange: Exchange.AOM },
    { code: "ZZADEF", exchange: Exchange.AOM },
    { code: "ZZAFGH", exchange: Exchange.AOM },
    { code: "ZZAGHI", exchange: Exchange.AOM },
    { code: "ZZAHIJ", exchange: Exchange.AOM },
    { code: "ZZAKT3", exchange: Exchange.AOM },
    { code: "ZZAKT4", exchange: Exchange.AOM },
    { code: "ZZAW61", exchange: Exchange.AOM },
    { code: "ZZAW62", exchange: Exchange.AOM },
    { code: "ZZAZ4", exchange: Exchange.AXF }
];
